import { render, staticRenderFns } from "./weChatData.vue?vue&type=template&id=2611ed79&scoped=true"
import script from "./weChatData.vue?vue&type=script&lang=js"
export * from "./weChatData.vue?vue&type=script&lang=js"
import style0 from "./weChatData.vue?vue&type=style&index=0&id=2611ed79&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2611ed79",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2611ed79')) {
      api.createRecord('2611ed79', component.options)
    } else {
      api.reload('2611ed79', component.options)
    }
    module.hot.accept("./weChatData.vue?vue&type=template&id=2611ed79&scoped=true", function () {
      api.rerender('2611ed79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/adver/weChatData.vue"
export default component.exports